import { userConstants } from "../../constant";

export function productMeta(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_PRODUCT_DATA:
      return {
        data: action.data,
        option_value: action.option_value,
      };

    default:
      return state;
  }
}
